import * as _ from 'lodash';
import { Dictionary } from 'types';

import { MatrixRowValue, Row } from '../types';

export function rowsHaveDifferentValues(firstRow: Pick<Row, 'cells'>, secondRow: Pick<Row, 'cells'>): boolean {
    return _.some(
        firstRow.cells,
        ({ value: firstValue }, key) => _.toNumber(firstValue) !== _.toNumber(_.get(secondRow.cells[key], 'value'))
    );
}

export function rowValueIsDifferent(rowValue: Pick<MatrixRowValue, 'row'>, row: Pick<Row, 'cells'>): boolean {
    return _.some(rowValue.row, (value, key) => _.toNumber(value) !== _.toNumber(_.get(row.cells[key], 'value')));
}

export function getRowValue(row: Pick<Row, 'cells'>): Dictionary {
    return _.reduce(
        row.cells,
        (rowValue, { value }, gtin) => ({
            ...rowValue,
            [gtin]: value
        }),
        {}
    );
}
